module.exports = __webpack_public_path__ + "static/img/barbecue.c966cf0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/barbecue.svg
// module id = jDha
// module chunks = 1